export default "__VITE_ASSET__7704253e__"